import { observer } from "mobx-react";
import { Field } from "mobx-react-form";

// Decision 13: a site address is one string; the structured Address/Suburb/City/
// State/Post Code fields are replaced everywhere a site is written (CR.6).
export const fields = [
  "sites",
  "sites[].companyRowID",
  "sites[].officeName",
  "sites[].division",
  "sites[].officeFullAddress",
  "sites[].totalNumberOfEmployees",
  "sites[].isPrimaryOffice",
];

export const labels = {
  sites: "Sites",
  "sites[].officeName": "Office Name",
  "sites[].division": "Division",
  "sites[].officeFullAddress": "Address",
  "sites[].totalNumberOfEmployees": "Total Employee Numbers",
  "sites[].isPrimaryOffice": "Primary Site",
};

export const values = {
  sites: [
    {
      companyRowID: "",
      officeName: "",
      division: "",
      officeFullAddress: "",
      totalNumberOfEmployees: "",
      isPrimaryOffice: true,
    },
  ],
};

export const rules = {
  "sites[].officeName": "string|required",
  "sites[].division": "string",
  "sites[].officeFullAddress": "string|required",
  "sites[].totalNumberOfEmployees": "numeric|required|min:1",
  "sites[].isPrimaryOffice": "required",
};

export const hooks = {
  sites: {
    onAdd(instance: Field) {
      instance.state.form.$("sites").map((v, i) => {
        v.$("isPrimaryOffice").observe({
          key: "value",
          call: ({ form, field, change }) => {
            if (field.value) {
              form.$("sites").map((site, ind) => {
                if (ind !== i) site.$("isPrimaryOffice").set("disabled", true);
              });
            } else {
              form.$("sites").map((site) => {
                site.$("isPrimaryOffice").set("disabled", false);
              });
            }
          },
        });
      });
      if (instance.state.form.values().sites.some((x) => x.isPrimaryOffice)) {
        instance
          .$(`${instance.size - 1}`)
          .$("isPrimaryOffice")
          .set("disabled", true);
      }
    },
  },
};

function getIndex(instance: Field) {
  return Number(instance.path.split(".")[1]);
}

export const types = {
  "sites[].totalNumberOfEmployees": "number",
};
